import { Rule } from '../rule'
import { uuid } from '../uuid'
import { DependOnOption, DisabledType } from '../common'

export class CascaderDef {
  key?: string = uuid()
  type: 'cascader' = 'cascader'
  model!: string
  label!: string
  dependOn?: DependOnOption
  options?: CascaderOptions = new CascaderOptions()
  rules?: Rule[]
}

export class CascaderOptions {
  props?: any
  defaultValue?: Array<string | number>
  disabled?: DisabledType = false
  placeholder?: string
  labelWidth?: string | number
  required?: boolean
  clearable?: boolean = true
  options?: any[]
  collapseTags?: boolean
  filterable?: boolean = true
  filterMethod?: (node: any, keyword: string) => boolean
  onChange?: (options: { value: any; form: Record<string, any>; rowForm: Record<string, any>; items: any[] }) => void
  onValueChange?: (options: { value: any; form: Record<string, any>; rowForm: Record<string, any>; items: any[] }) => void
}
